// @ts-nocheck
import {
  AddCircle,
  Assignment,
  Chat,
  Edit,
  Visibility,
} from '@mui/icons-material';
import { Typography } from '@mui/material';
import { MyContext } from 'Context';
import { getLocalStorageItem } from 'hooks';
import { useAuthMe } from 'queries/AuthQueries';
import { useChangePatientStatusApi } from 'queries/Patient';
import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ReactJoyride, { ACTIONS, EVENTS, STATUS } from 'react-joyride';
import { useNavigate } from 'react-router-dom';

interface Option {
  id: string;
  name: string;
}

interface TourGuideProps {
  options: Option[];
}

const CustomComponentStepOne: React.FC<CustomComponentProps> = () => {
  const { t } = useTranslation('tour');

  return (
    <div className="rounded-lg">
      <h2 className="text-3xl mb-6 font-bold text-primary-500">
        {t('welcomeToMessaging')}
      </h2>
      <p className="mb-4 text-gray-700">{t('interactiveMessagingSpace')}</p>
      <div className="flex items-center space-x-1 text-gray-700">
        <Chat className="text-xl text-primary-500" />
        <span className="text-xs text-primary-500">
          {t('engageInSeamlessConversations')}
        </span>
      </div>
      <div className="mt-2 flex items-center  space-x-1 text-gray-700">
        <Chat className="text-xl text-primary-500" />
        <span className="text-xs text-primary-500">
          {t('expressYourselfWithFeatures')}
        </span>
      </div>
      <div className="mt-2 flex items-center  space-x-1 text-gray-700">
        <Chat className="text-xl text-primary-500" />
        <span className="text-xs text-primary-500">
          {t('enjoyVisuallyAppealingUI')}
        </span>
      </div>
      <div className="mt-2 flex items-center space-x-1 text-gray-700">
        <Chat className="text-xl text-primary-500" />
        <span className="text-xs text-primary-500">
          {t('experienceRealTimeUpdates')}
        </span>
      </div>
      <p className="mt-4 text-gray-700">{t('getReadyToElevate')}</p>
    </div>
  );
};

const CustomComponentStepTwo: React.FC<CustomComponentProps> = () => {
  const { t } = useTranslation('tour');

  return (
    <div className="rounded-lg p-1">
      <h2 className="text-3xl mb-6 font-bold text-primary-500">
        {t('requestManagement')}
      </h2>
      <p className="mb-4 text-gray-700">{t('welcomeRequestManagement')}</p>
      <Typography className="flex items-center text-left text-xs text-primary-500">
        <Assignment className="mr-2 text-xl text-primary-500" />{' '}
        {t('createNewRequestsEffortlessly')}
      </Typography>
      <Typography className="my-2 flex items-center text-left text-xs text-primary-500">
        <Assignment className="mr-2 text-xl text-primary-500" />{' '}
        {t('browseYourNewRequests')}
      </Typography>
      <Typography className="flex items-center text-left text-xs text-primary-500">
        <Assignment className="mr-2 text-xl text-primary-500" />{' '}
        {t('efficientlyProceedWithRequests')}
      </Typography>

      <p className="text-gray-700">{t('elevateYourRequests')}</p>
    </div>
  );
};
const CustomComponentStepThree: React.FC<CustomComponentProps> = () => {
  const { t } = useTranslation('tour');

  return (
    <div className=" rounded-lg p-1">
      <h2 className="text-3xl text-green-600 mb-6 font-bold">
        {t('addingANewRequest')}
      </h2>
      <p className="mb-4 text-gray-700">
        {t('click')}{' '}
        <span className="text-primary-500"> {t('newRequest')}</span>{' '}
        {t('buttonToRequest')}
        <span className="text-primary-500"> {t('reqNew')}</span> tab.
      </p>
      <div className="flex flex-col items-center space-y-4 text-gray-700">
        <div className="flex items-center">
          <AddCircle className="text-green-500 text-3xl" />
          <span className="ml-2 font-semibold">{t('newRequest')}</span>
        </div>
        <span className="text-gray-500">{t('toSee')}</span>
        <div className="flex items-center">
          <Visibility className="text-3xl text-primary-500" />
          <span className="ml-2 font-semibold">{t('requestSection')}</span>
        </div>
      </div>
    </div>
  );
};

const CustomComponentStepFour: React.FC<CustomComponentProps> = () => {
  const { t } = useTranslation('tour');

  return (
    <div className="rounded-lg  p-2">
      <h2 className="text-3xl mb-6 font-bold text-primary-500">
        {t('manageYourProfile')}
      </h2>
      <p className="mb-4 text-gray-700">{t('accessAndEditProfileDetails')}</p>
      <div className="flex items-center space-x-2 text-gray-700">
        <Edit className="text-2xl text-primary-500" />
        <span className="font-semibold">{t('editYourProfileInformation')}</span>
      </div>
    </div>
  );
};

const TourGuide: React.FC<TourGuideProps> = ({ options }) => {
  const { data: profileData } = useAuthMe();
  const { runDemo, setRunDemo } = useContext(MyContext);
  // const [run, setRun] = useState<boolean>(false);
  const [stepIndex, setStepIndex] = useState<number>(0);
  const [nextButtonEnabled, setNextButtonEnabled] = useState<boolean>(false);
  const navigate = useNavigate();

  useEffect(() => {
    setNextButtonEnabled(false);
    const timer = setTimeout(() => {
      setNextButtonEnabled(true);
    }, 3000);
    return () => clearTimeout(timer);
  }, [stepIndex]);

  const steps = [
    // {
    //   target: `#PatientsMessagingDemo`,
    //   content: <CustomComponentStepOne />,
    //   placement: 'right',
    //   disableBeacon: true,
    // },
    {
      target: `#RequestDemo`,
      content: <CustomComponentStepTwo />,
      placement: 'right',
      disableBeacon: true,
    },
    {
      target: '#addnewrequestid',
      content: <CustomComponentStepThree />,
      placement: 'left',
    },
    {
      target: '#profile-details-id',
      content: <CustomComponentStepFour />,
      placement: 'top',
    },
  ];
  const UserDetails = getLocalStorageItem('roles');
  const headerKeys = {
    'x-klynex-access-key':
      profileData?.data?.account?.patientsAccessKey ||
      UserDetails?.account?.patientsAccessKey,
  };
  const { mutate: changePatientStatusApi } =
    useChangePatientStatusApi(headerKeys);
  const handleJoyrideCallback = (data: any) => {
    const { action, index, type, status } = data;

    if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
      if (index === 0 && action === ACTIONS.NEXT) {
        navigate('/requests');
        setStepIndex(1);
        return;
      }

      if (index === 2 && action !== ACTIONS.PREV) {
        const payload = {
          accountId: profileData?.data?.account?.id,
          uuid: profileData?.data?.uuid,
        };

        changePatientStatusApi(payload, {
          onSuccess: () => {
            if (status === STATUS.FINISHED || index === steps.length - 1) {
              setRunDemo(false);
              navigate('/requests');
              window.location.reload(false);
            } else {
              setStepIndex(index + 1);
            }
          },
          onError: (error) => {},
        });
        return;
      }

      setStepIndex(index + (action === ACTIONS.PREV ? -1 : 1));
    }

    if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      setRunDemo(false);
      navigate('/requests');
      window.location.reload(false);
    }
  };

  useEffect(() => {
    if (profileData?.data?.patient?.status === 'Invited') {
      setRunDemo(true);
    }
  }, [profileData?.data?.patient?.status]);

  return (
    <ReactJoyride
      disableBeaco={true}
      spotlightClicks
      continuous
      run={runDemo}
      steps={steps}
      stepIndex={stepIndex}
      callback={handleJoyrideCallback}
      disableCloseOnEsc
      showProgress
      disableOverlayClose
      hideCloseButton
      scrollToSteps
      styles={{
        options: {
          arrowColor: '#e3ffeb',
          backgroundColor: '#e3ffeb',
          primaryColor: '#088ab2',
          textColor: '#004a14',
          zIndex: 1000,
        },
        tooltip: {
          marginTop: '20px',
          padding: '10px',
        },
        tooltipContent: {
          padding: '0px',
        },
        buttonNext: {
          opacity: nextButtonEnabled ? 1 : 0.5,
          cursor: nextButtonEnabled ? 'pointer' : 'not-allowed',
        },
      }}
    />
  );
};

export default TourGuide;
